exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sw-table-unpublish[data-v-39392864]{font-size:12px;color:#f5a623;line-height:22px}.sw-table-unpublish[data-v-39392864]:before{width:8px;height:8px;background:#f5a623;border-radius:4px;display:inline-block;content:\"\"}", ""]);

// exports
